import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import FootballList from './pages/FootballList';
import NetballList from './pages/NetballList';
import VolleyballbList from './pages/VolleyballBList';
import Landing from './pages/Landing';
import VolleyballsList from './pages/VolleyballSList';
import TeamsDisplay from './pages/Tables';
import BadmintonbList from './pages/BadmintonbList';
import BadmintonsList from './pages/BadmintonsList';


const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/futsal" element={<FootballList />} />
        <Route path="/netball" element={<NetballList />} />
        <Route path="/volleyballb" element={<VolleyballbList />} />
        <Route path="/volleyballs" element={<VolleyballsList />} />
        <Route path="/badmintonb" element={<BadmintonbList />} />
        <Route path="/badmintons" element={<BadmintonsList />} />
        <Route path="/scoreboard" element={<TeamsDisplay />} />
       
        {/* Add more routes here as needed */}
      </Routes>
    </Router>
  );
};

export default App;
